import api from "../../../services/api";

// 🔹 BOOTSTRAP DA HOME
export async function fetchHomeBootstrap() {
  const mePromise = api.get("/users/me").catch(() => null);
  const profilePromise = api.get("/users/profile").catch(() => null);
  const dosesPromise = api.get("/doses").catch(() => null);
  const waterPromise = api.get("/water/today").catch(() => null);

  const [meRes, profileRes, dosesRes, waterRes] = await Promise.all([
    mePromise,
    profilePromise,
    dosesPromise,
    waterPromise,
  ]);

  return {
    me: meRes?.data || null,
    profile: profileRes?.data || null,
    doses: Array.isArray(dosesRes?.data) ? dosesRes.data : [],
    waterToday: waterRes?.data || null,
  };
}

// 🔹 ÁGUA
export async function fetchTodayWater() {
  const response = await api.get("/water/today");
  return response?.data || null;
}

export async function addWaterLog({ cups = 1, ml = 250 } = {}) {
  const response = await api.post("/water/log", { cups, ml });
  return response?.data || null;
}

// 🔹 PESO (PADRONIZADO)
export async function saveWeightMeasurement({ date, weightKg, notes }) {
  const payload = {
    date,
    weightKg,
  };

  const trimmedNotes = typeof notes === "string" ? notes.trim() : "";
  if (trimmedNotes) {
    payload.notes = trimmedNotes;
  }

  const response = await api.post("/measurements/weight", payload);
  return response?.data || null;
}

// 🔹 MEDIDAS CORPORAIS (PADRONIZADO)
export async function saveBodyMeasurement(payload) {
  const response = await api.post("/measurements/body", payload);
  return response?.data || null;
}